import { Badge, styled, Avatar as MuiAvatar } from '@mui/material';
import { UserAreaType } from '../../../types/sidebar.types';

export const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: theme.palette.success.main,
        color: theme.palette.success.main,
        boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
        position: 'absolute',
        left: '0px',
        bottom: '3px',
        '&::after': {
            position: 'absolute',
            top: '-1',
            left: '-1',
            width: '100%',
            height: '100%',
            borderRadius: '50%',
            animation: 'ripple 1.2s infinite ease-in-out',
            border: '1px solid currentColor',
            content: '""',
        },
    },
    '@keyframes ripple': {
        '0%': {
            transform: 'scale(.8)',
            opacity: 1,
        },
        '100%': {
            transform: 'scale(2.4)',
            opacity: 0,
        },
    },
}));

const AvatarComponent = ({
    avatar,
    name,
    avatar_color,
    badge,
}: Pick<UserAreaType, 'avatar' | 'avatar_color' | 'name' | 'badge'>) => {
    const avatarElement = (
        <MuiAvatar
            variant="rounded"
            sx={{
                background: avatar_color,
                color: 'primary.contrastText',
            }}
            src={avatar}
            alt={name}>
            {name?.substring(0, 1)}
        </MuiAvatar>
    );

    return (
        <>
            {badge ? (
                <StyledBadge
                    overlap="circular"
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    variant="dot">
                    {avatarElement}
                </StyledBadge>
            ) : (
                avatarElement
            )}
        </>
    );
};

export default AvatarComponent;
